import { api } from '../index';

const prefix = '/api/item/inventory/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectInventoryHistoryList(param) {
	return api.post(prefix + 'selectInventoryHistoryList', param);
}

export function apiAdjustBatch(param) {
	return api.post(prefix + 'adjustBatch', param);
}

export function apiSelectLotList(param) {
	return api.post(prefix + 'selectLotList', param);
}

export function apiAdjustInventory(param) {
	return api.post(prefix + 'adjustInventory', param);
}

export function apiAddLot(param) {
	return api.post(prefix + 'addLot', param);
}

export function apiSaveLots(param) {
	return api.post(prefix + 'saveLots', param);
}

export function apiSelectRepackList(param) {
	return api.post(prefix + 'selectRepackList', param);
}

export function apiSaveRepacks(param) {
	return api.post(prefix + 'saveRepacks', param);
}

export function apiRepack(param) {
	return api.post(prefix + 'repack', param);
}

export function apiSubdivide(param) {
	return api.post(prefix + 'subdivide', param);
}

export function apiSelectRepackHistoryList(param) {
	return api.post(prefix + 'selectRepackHistoryList', param);
}

// export function apiCheckItemExists(param) {
// 	return api.post(prefix + 'checkItemExists', param);
// }

// export function apiInsertItem(param) {
// 	param.mode = 'insert';
// 	return apiSubmitItem(param);
// }

// export function apiUpdateItem(param) {
// 	param.mode = 'update';
// 	return apiSubmitItem(param);
// }

// export function apiDeleteItem(param) {
// 	param.mode = 'delete';
// 	return apiSubmitItem(param);
// }

// function apiSubmitItem(param) {
// 	return api.post(prefix + 'submitItem', param);
// }

export function apiAddInventoryTransaction(param) {
	return api.post(prefix + 'addInventoryTransaction', param);
}

export function apiSelectInventoryTransactionList(param) {
	return api.post(prefix + 'selectInventoryTransactionList', param);
}
